<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll" id="wishList-infinite">
            <div class="wishList scroll-container">
                <div class="wishList-container" v-if="wishList.length > 0">
                    <div class="item-body" v-for="(item, index) in wishList" :key="item.cruiseId">
                        <div class="item-cruiseName" @click="goto(item)">{{interceptTitle(item.cruiseName, 50)}}</div>
                        <div class="item-cruise-content">
                            <div class="item-leftCon">
                                <img class="wishListImg" :src="item.mobileImage">
                                <div class="hotIcon">
                                    爆款
                                </div>
                                <div class="hot-text">
                                    <span v-html="getText(item.supportDescription)"></span>
                                </div>
                            </div>
                            <div class="item-rightCon">
                                <div class="item-sailDate">
                                    <div>
                                        <span>{{item.routeDays}}天{{item.routeDays - 1}}晚</span>
                                        <span class="item-shipName">{{item.shipCNName}}</span>
                                    </div>
                                    <router-link tag="div" :to="`/Rccl.Cruise/CruiseSearch/CruiseCalendar?shipCode=${item.shipCode}&sailDate=${item.sailDate}&routeCode=${item.cruiseName}`" class="item-sailDate-content">
                                        <span>{{item.sailDateBegin}} - {{item.sailDateEnd}}</span>
                                        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/calendarIcon.png" class="js-getCruiseByRoute">
                                    </router-link>
                                </div>
                                <div class="item-tags">
                                    <span v-for="(tag, tagIndex) in item.tags" :key="tagIndex" v-bind:class="{hot: tag.isHighShow}" @click="toTagLink(tag.tagLink)">{{tag.tagType}}</span>
                                </div>
                                <div class="item-price-no-package" v-if="item.netAmount>0">
                                    <div class="item-price-cruiseonly" data-link="/Rccl.Cruise/CruiseDetail?sailDate=2020-11-15&amp;shipCode=SC">
                                        <span class="item-price-title">{{item.isRow ? '单船票' : (item.isnrpPrice ? '早订特惠价' : '优惠价')}}</span>
                                        <span class="item-price">￥<span class="item-priceNum">{{item.netAmount}}</span>/人起 &gt;</span>

                                    </div>
                                    <div>平均每晚￥{{item.amountPerNight}}/人起</div>
                                </div>
                                <div v-else class="item-price-no-package">售罄</div>
                            </div>
                        </div>
                        <div class="cruise-button">
                            <div class="item-button">
                                <div class="item-cancelWish item-cruise-button" @click="opeDelete(item, index)">
                                    <img src="https://resource.rcclchina.com.cn/tui2/user_center/delete_icon.png">
                                    <span>取消收藏</span>
                                </div>
                                <div class="item-cruiseWish item-cruise-button" @click="findSimilarities(item)">
                                    <img src="https://resource.rcclchina.com.cn/tui2/user_center/similar_icon.png">
                                    <span>找相似</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--收藏夹为空提示-->
                <div class="noWishList-container" v-else>
                    <div class="noWishList-fileIcon">
                        <img src="https://resource.rcclchina.com.cn/tui2/user_center/wishlist_empty.png">
                    </div>
                    <p>好可惜，您的收藏夹还是空的~</p>
                    <p>这怎么能行，快来添加您的美好旅行计划吧！</p>
                    <router-link tag="div" to="/Rccl.Cruise/CruiseSearch/Search" class="noWishList-searchBtn">
                        <img src="https://resource.rcclchina.com.cn/tui2/user_center/search_icon.png">
                        <span>搜索及添加心仪航线</span>
                    </router-link>
                </div>
                <!-- 推荐航线 -->
                <PromoCruise></PromoCruise>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import { interceptChar } from '@/utilities/tools'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    export default {
        name: 'Coupon',
        components: {
            PromoCruise
        },
        data () {
            return {
                userToken: '',
                wishList: []
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '收藏夹')
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                const userToken = this.$store.state.user.userToken
                if (!userToken || userToken.length == 0) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return
                }
                this.userToken = userToken

                const data = await this.getWishList({
                    userName: userToken,
                    Offset: 0,
                    Limit: 10
                })
                this.wishList = data.cruises
            },
            async getWishList (requestData) {
                const {success, data, errMsg} = await api.cruise.getWishList(requestData)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            opeDelete (item, index) {
                let that = this
                this.$confirm.show('确认取消收藏该航线吗？', {
                    title: '温馨提示',
                    confirmBtn: '再想想',
                    cancelBtn: '确认取消',
                    confirmCallBack () {},
                    cancelCallBack () {
                        that.deleteWish(item, index)
                    }
                })
            },
            async deleteWish (item, index) {
                const {success, data, errMsg} = await api.cruise.deleteWishList({userName: this.userToken, cruiseId: item.cruiseId})
                if (!success) {
                    console.log(errMsg)
                } else {
                    console.log(data)
                }
                this.wishList.splice(index, 1)
            },
            interceptTitle (string, num) {
                return interceptChar(string, num)
            },
            goto (item) {
                if (item.isRow) {
                    this.$router.push(`/Rccl.Cruise/CruiseDetail?shipCode=${item.shipCode}&sailDate=${item.sailDate}&cruiseId=${item.cruiseId}`)
                } else {
                    this.$router.push(`/Rccl.Cruise/CruiseDetail?shipCode=${item.shipCode}&sailDate=${item.sailDate}`)
                }
            },
            toTagLink (tagLink) {
                if (!tagLink) return false
                window.location.href = tagLink
            },
            getText (text) {
                if (text) return text.replace(/\s+/g, '<br>')
                return ''
            },
            findSimilarities (item) {
                let shipCodes = item.shipCode
                let departureCodes = (item.routeEvents.find(item => item.day === 1)).harborCode
                let destinationCodes = ''
                let destinationArr = []
                item.routeEvents.map(ele => {
                    if (ele.harborCode && ele.harborCode.indexOf("CRU_")<0 
                    && departureCodes.indexOf(ele.harborCode) < 0
                    && destinationArr.indexOf(ele.harborCode) < 0) {
                        destinationArr.push(ele.harborCode)
                    }
                })
                destinationCodes = destinationArr.toString()
                let sailDays = 6
                if (item.routeDays - 1 == 4) {
                    sailDays = 4
                } else if (item.routeDays - 1 == 5) {
                    sailDays = 5
                }
                
                if (item.isRow) {
                    window.location.href = `/Rccl.Cruise/CruiseSearch/SearchRow?shipCodes=${shipCodes}&departureCodes=${departureCodes}&destinationCodes=${destinationCodes}&sailDays=${sailDays}`
                } else {
                    this.$router.push(`/Rccl.Cruise/CruiseSearch/Search?shipCodes=${shipCodes}&departureCodes=${departureCodes}&destinationCodes=${destinationCodes}&sailDays=${sailDays}`)
                }
            }
        }
    }
</script>

<style scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }
    .wishList {
        padding: 50px 0 50px;
        background: #F6F7F8;
    }
    .wishList-container {
    }
    .wishList-container .item-body {
        background-color:#fff;
        padding: 13px 10px 0px 20px;
        margin-bottom:8px;
        overflow:hidden;
        position:relative;
    }
    .wishList-container .item-body .hold-link,
    .hotCruise-item .hold-link{
        width:100%;
        height:100%;
        position:absolute;
        top:0;
        left:0;
        z-index:111;
    }
    .wishList-container .item-leftCon {
        position: relative;
        width: 120px;
        display: inline-block;
        vertical-align: top;
    }
    .wishList-container .item-leftCon .wishListImg {
        width:100%;
        display: block;
        /*width:97px;
        height:129px;*/
    }
    .wishList-container .item-leftCon .hotIcon {
        height: 19px;
        line-height: 15px;
        position: absolute;
        top: 9px;
        left: -5px;
        background: #FF5055;
        
        font-size: 12px;
        color: #FFFFFF;
        letter-spacing: 1.57px;
        text-align: center;
        padding: 2px 6px;
    }

    .wishList-container .item-leftCon .hotIcon:after {
        content: '';
        width: 0;
        height: 0;
        border: 3px solid #D1282D;
        border-bottom-color: transparent;
        border-left-color: transparent;
        position: absolute;
        bottom: -6px;
        left: 0;
    }


    .wishList-container .item-leftCon .hotIcon img{
        width:100%;
    }

    .wishList-container .item-leftCon .hot-text {
        position: absolute;
        width: 100%;
        left: 0px;
        bottom: 0px;
        height: 60px;
        background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.64) 92%);
        
        font-size: 11px;
        color: #FFFFFF;
        letter-spacing: 1.57px;
        text-align: center;
        display: flex;
        padding-bottom: 10px;
    }

    .wishList-container .item-leftCon .hot-text span {
        display: inline-block;
        align-self: flex-end;
        margin: 0 auto;
    }


    .wishList-container .item-rightCon {
        display: inline-block;
        vertical-align: top;
        margin-left: 10px;
    }
    .wishList-container .item-rightCon p{
        margin:0;
    }
    .wishList-container .item-cruiseName{
        
        font-size: 13px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
    }

    .wishList-container .item-cruise-content {
        margin-top: 6.5px;
        position: relative;
    }

    .wishList-container .item-rightCon .item-sailDate{
        
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        margin-top: 3px;
    }

    .wishList-container .item-rightCon .item-sailDate>div {
        margin-bottom: 5px;
    }

    .wishList-container .item-rightCon .js-getCruiseByRoute{
        width: 15px;
        position: relative;
        top: 2px;
        left: 5px;
    }

    .wishList-container .item-rightCon .item-price-no-package
    , .wishList-container .item-rightCon .item-price-with-package {
        margin-top: 5px;
        
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
    }

    .wishList-container .item-rightCon .item-price .item-priceNum{
        
        font-size: 18px;
        color: #FF5055;
    }

    .wishList-container .item-rightCon .item-price-with-package .item-price-package {
        margin-top: 10px;
        border: 1px solid #FEBC10;
        position: relative;
        padding-left: 3px;
        left: -3px;
    }

    .wishList-container .item-rightCon .item-price-with-package .item-price-cruiseonly {
        display: inline-block;
        border-bottom: 1px solid #979797;
    }

    .wishList-container .item-rightCon .item-price-with-package .item-package-booking {
        background-image: linear-gradient(90deg, #F4CA57 0%, #F5CF60 100%);
        
        font-size: 12px;
        color: #454545;
        letter-spacing: 1px;
        padding: 3px 9px;
        appearance: none;
        -webkit-appearance: none;
        border: none;
        display: inline-block;
        line-height: 24px;
    }

    .wishList-container .item-rightCon .item-price-no-package .item-price-cruiseonly .item-priceNum {
        font-weight: bold;
    }

    .wishList-container .item-rightCon .item-price-with-package .item-price-package .item-priceNum {
        font-weight: bold;
    }

    .wishList-container .item-rightCon .item-shipName {
        margin-left:11px;
    }
    .wishList-container .item-rightCon .item-tags{
        margin-top:8px !important;
        width: 200px;
    }
    .wishList-container .item-rightCon .item-tags span{
        background: rgba(37,96,212,0.05);
        border-radius: 8px;
        
        font-size: 10px;
        color: #4A90E2;
        letter-spacing: 1px;
        text-align: center;
        padding: 2px 5px;
        margin-right: 5px;
        display: inline-block;
        vertical-align: top;
    }
    .wishList-container .item-rightCon .item-tags span.hot{
        background: #FEBC10;
        color: #fff;
    }

    .wishList-container .item-rightCon .item-button{
        text-align:right;
        margin-top:25px;
    }
    .wishList-container .item-rightCon .item-cancelWish{
        border:1px solid #666;
        color:#666;
        font-size:13px;
        padding:7px 10px 10px 10px;
        border-radius: 3px;
    }

    .wishList-container .item-rightCon .item-cruiseWish {
        color:#fcbb11;
        font-size:13px;
        padding:7px 10px 10px 10px;
        background-color:#fff;
        margin-left:5px;
        border: solid 1px #fcbb11;
        display:inline-block;
        border-radius: 3px;
    }

    .wishList-container .item-rightCon .item-cruiseWish a {
        display:inline-block;
        width:100%;
        height:100%;
        color:#fcbb11;
        text-decoration:none;
    }

    .wishList-container .item-rightCon .item-orderCruise{
        color:#fff;
        font-size:13px;
        padding:7px 10px 10px 10px;
        background-color:#fcbb11;
        margin-left:5px;
        display:inline-block;
        border-radius: 3px;
    }

    .wishList-container .item-rightCon .disable {
        background: #ddd;
    }

    .wishList-container .item-rightCon .item-orderCruise a{
        display:inline-block;
        width:100%;
        height:100%;
        color:#fff;
        text-decoration:none;
    }

    .wishList-container .item-body .cruise-button {
        border-top: 1px solid rgba(204,204,204,0.3);
        position: relative;
        padding: 9px 0px;
        margin-top: 7px;
    }

    .cruise-button .item-cruise-button {
        display: inline-block;
        vertical-align: top;
        width: 49%;
        text-align: center;
        
        font-size: 12px;
        color: #4A90E2;
        letter-spacing: 1.71px;
        line-height: 25px;
    }

    .cruise-button .item-cancelWish img {
        width: 11px;
        position: relative;
        top: 1px;
        margin-right: 5px;
    }


    .cruise-button .item-cruiseWish img {
        width: 14px;
        position: relative;
        top: 2px;
        margin-right: 5px;
    }

    .cruise-button .item-cruise-button:first-child {
        border-right: 1px solid rgba(204,204,204,0.5);
    }

    /**** 收藏夹为空提示 ****/
    .bgActive {
        background-color:#fff !important;
    }
    .noWishList-container {
        text-align: center;
        padding-top: 75px;
        padding-bottom:30px;

        
        font-size: 14px;
        color: #AAAAAA;
        letter-spacing: 0;
        text-align: center;
        line-height: 20px;
    }
    .noWishList-fileIcon {
        width: 100%;
        text-align: center;
        margin-bottom: 13px;
    }
    .noWishList-fileIcon>img {
        width:50px;
    }
    .noWishList-container > p {
        margin-top: 0;
        margin-bottom:4px;
    }
    .noWishList-searchBtn {
        margin-top:10px;
        display:inline-block;
        border: 1px solid #4A90E2;
        border-radius: 14px;
        border-radius: 14px;
        color: #4A90E2;
        width: 180px;
        line-height: 22px;
        text-decoration:none;
        margin-bottom: 20px;
    }
    .noWishList-searchBtn>img{
        width:13px;
        vertical-align:middle;
    }
</style>
